// extracted by mini-css-extract-plugin
export var label = "_8z-1";
export var reminder = "_8z-0";